/**
 * Returns Gov-Test-Scenario header if configured and not in production
 */
export function getTestScenarioHeader(): Record<string, string> {
    // Check if the environment is 'production' OR 'prod'
    const isProduction = import.meta.env.VITE_ENV === "production" || import.meta.env.VITE_ENV === "prod";

    const scenario = import.meta.env.VITE_HMRC_GOV_TEST_SCENARIO;

    if (!isProduction && scenario) {
        return { "x-gov-test-scenario": scenario };
    }

    return {};
}
